import { useEffect, useState } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

import { useFetchClientListForPanel, useFetchUserDetail } from '@/services';

export const useVenueManagement = () => {
  const { venueId, clientId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [venueIds, setVenueIds] = useState<string>('');
  const [hasVenue, setHasVenue] = useState<boolean>(false);
  const { data: clientPanel } = useFetchClientListForPanel();
  const user = useFetchUserDetail();
  const { pathname } = useLocation();
  const rootPath = '/' + pathname.split('/')[1];
  const clientPanelContent = clientPanel?.content;

  const getVenueIds = () => {
    const myVenueIds = user?.responsibleVenues
      ?.map((venue) => venue.id)
      .toString();
    setHasVenue(myVenueIds?.length > 0);

    const myClientsOnly = searchParams.get('my') === 'true';
    if (myClientsOnly) {
      return myVenueIds;
    } else if (clientId) {
      return clientPanelContent
        ?.find((client) => client.id === Number(clientId))
        ?.venues.filter((venue) => venue.hasCleanierUser)
        .map((venue) => venue.id)
        .toString();
    } else {
      return clientPanelContent
        ?.map((client) =>
          client.venues
            .filter((venue) => venue.hasCleanierUser)
            .map((venue) => venue.id)
        )
        .flat()
        .toString();
    }
  };
  useEffect(() => {
    if (clientPanel && rootPath === '/chat') {
      const venueIds = getVenueIds();
      setVenueIds(venueIds);
      if (venueIds?.length === 0) {
        searchParams.delete('my');
        navigate(
          { pathname: `/chat/all`, search: searchParams.toString() },
          { replace: true }
        );
      }
    }
  }, [clientPanel]);

  return { venueIds, hasVenue };
};
